// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.proyectsDataToChange-container {
    width: 100%;
    margin: 0;
    overflow-y: scroll;
    margin-bottom: 150px;
}

.proyectsToActivate-container .noProyectsToEdit {
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
}

.proyectsDataToChange-container > div {
    width: 100%;
    background-color: #0e0f15;
    border: 3px solid #f09502;
}

.proyectsDataToChange-container .currentData {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.proyectsDataToChange-container .currentData .image-container {
    width: 25%;
    min-height: 150px;
    position: relative;
}

.proyectsDataToChange-container .currentData .image-container img {
    width: 100%;
    height: auto;
    max-height: 200px;
    object-fit: cover;
    border-radius: 4px;
}

.proyectsDataToChange-container .currentData .image-placeholder,
.proyectsDataToChange-container .currentData .image-error-placeholder {
    width: 100%;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #1a1d29;
    border: 2px dashed #444;
    border-radius: 4px;
    color: #6c757d;
}

.proyectsDataToChange-container .currentData .image-container .image-error-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: none;
}

.proyectsDataToChange-container .currentData > div {
    width: 75%;
    padding-left: 15px;
}

.proyectsDataToChange-container .setData {
    width: 100%;
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    flex-wrap: wrap;
}

.proyectsDataToChange-container .setData button {
    flex: 0 0 auto;
    white-space: nowrap;
}

/* Estilo para botón rojo habilitado - debe verse rojo siempre */
.proyectsDataToChange-container .setData .btn-danger:not(:disabled),
.proyectsDataToChange-container .setData .btn-danger:not([disabled]) {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
    color: #ffffff !important;
    font-weight: 500 !important;
}

/* Hover del botón rojo habilitado - más fuerte */
.proyectsDataToChange-container .setData .btn-danger:not(:disabled):hover,
.proyectsDataToChange-container .setData .btn-danger:not([disabled]):hover {
    background-color: #c82333 !important;
    border-color: #bd2130 !important;
    color: #ffffff !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.4) !important;
}

/* Estilo para botón disabled - debe verse rojo siempre */
.proyectsDataToChange-container .setData .btn-danger:disabled,
.proyectsDataToChange-container .setData .btn-danger[disabled] {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
    color: #ffffff !important;
    opacity: 0.65 !important;
    cursor: not-allowed !important;
}

.proyectsDataToChange-container .setData .btn-danger:disabled:hover,
.proyectsDataToChange-container .setData .btn-danger[disabled]:hover {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
    opacity: 0.65 !important;
}

@media (max-width: 500px) {
    .proyectsDataToChange-container .currentData .image-container,
    .proyectsDataToChange-container .currentData .image-placeholder {
        width: 100%;
        margin-bottom: 8px;
    }

    .proyectsDataToChange-container .currentData img {
        width: 100%;
        margin-bottom: 8px;
    }

    .proyectsDataToChange-container .currentData > div {
        width: 100%;
        padding-left: 0;
    }

    .proyectsDataToChange-container .setData {
        flex-direction: column;
        justify-content: stretch;
    }

    .proyectsDataToChange-container .setData button {
        width: 100%;
        margin-bottom: 0.5rem;
    }

    .proyectsDataToChange-container .setData button:last-child {
        margin-bottom: 0;
    }
}

/* Estilos para el panel de filtros */
.filters-panel .card {
    background-color: #1a1d29;
    border: 2px solid #f09502;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.filters-panel .card-header {
    background-color: #0e0f15;
    border-bottom: 2px solid #f09502;
    padding: 0.75rem 1rem;
}

.filters-panel .card-header h6 {
    color: #f09502;
    font-weight: 600;
    margin: 0;
}

.filters-panel .card-body {
    padding: 1rem;
    background-color: #1a1d29;
}

.filters-panel .form-label {
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 0.5rem;
}

.filters-panel .form-select {
    background-color: #2a2d3a;
    border: 1px solid #444;
    border-radius: 4px;
    padding: 0.375rem 0.75rem;
    color: #ffffff;
}

.filters-panel .form-select:focus {
    background-color: #2a2d3a;
    border-color: #f09502;
    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);
    color: #ffffff;
}

.filters-panel .form-select option {
    background-color: #2a2d3a;
    color: #ffffff;
}

.filters-panel .btn-outline-secondary {
    border-color: #f09502;
    color: #f09502;
    background-color: transparent;
}

.filters-panel .btn-outline-secondary:hover {
    background-color: #f09502;
    border-color: #f09502;
    color: #000000;
}

.filters-panel .text-muted {
    color: #adb5bd !important;
}

/* Responsive para filtros */
@media (max-width: 768px) {
    .filters-panel .row .col-md-4 {
        margin-bottom: 1rem;
    }
    
    .filters-panel .card-body {
        padding: 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/proyects-set-data/proyects-set-data/proyects-set-data.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,gEAAgE;AAChE;;IAEI,oCAAoC;IACpC,gCAAgC;IAChC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,iDAAiD;AACjD;;IAEI,oCAAoC;IACpC,gCAAgC;IAChC,yBAAyB;IACzB,2BAA2B;IAC3B,uDAAuD;AAC3D;;AAEA,yDAAyD;AACzD;;IAEI,oCAAoC;IACpC,gCAAgC;IAChC,yBAAyB;IACzB,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;;IAEI,oCAAoC;IACpC,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI;;QAEI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,qCAAqC;AACrC;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.proyectsDataToChange-container {\n    width: 100%;\n    margin: 0;\n    overflow-y: scroll;\n    margin-bottom: 150px;\n}\n\n.proyectsToActivate-container .noProyectsToEdit {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n}\n\n.proyectsDataToChange-container > div {\n    width: 100%;\n    background-color: #0e0f15;\n    border: 3px solid #f09502;\n}\n\n.proyectsDataToChange-container .currentData {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.proyectsDataToChange-container .currentData .image-container {\n    width: 25%;\n    min-height: 150px;\n    position: relative;\n}\n\n.proyectsDataToChange-container .currentData .image-container img {\n    width: 100%;\n    height: auto;\n    max-height: 200px;\n    object-fit: cover;\n    border-radius: 4px;\n}\n\n.proyectsDataToChange-container .currentData .image-placeholder,\n.proyectsDataToChange-container .currentData .image-error-placeholder {\n    width: 100%;\n    min-height: 150px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #1a1d29;\n    border: 2px dashed #444;\n    border-radius: 4px;\n    color: #6c757d;\n}\n\n.proyectsDataToChange-container .currentData .image-container .image-error-placeholder {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: none;\n}\n\n.proyectsDataToChange-container .currentData > div {\n    width: 75%;\n    padding-left: 15px;\n}\n\n.proyectsDataToChange-container .setData {\n    width: 100%;\n    display: flex;\n    gap: 0.5rem;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n}\n\n.proyectsDataToChange-container .setData button {\n    flex: 0 0 auto;\n    white-space: nowrap;\n}\n\n/* Estilo para botón rojo habilitado - debe verse rojo siempre */\n.proyectsDataToChange-container .setData .btn-danger:not(:disabled),\n.proyectsDataToChange-container .setData .btn-danger:not([disabled]) {\n    background-color: #dc3545 !important;\n    border-color: #dc3545 !important;\n    color: #ffffff !important;\n    font-weight: 500 !important;\n}\n\n/* Hover del botón rojo habilitado - más fuerte */\n.proyectsDataToChange-container .setData .btn-danger:not(:disabled):hover,\n.proyectsDataToChange-container .setData .btn-danger:not([disabled]):hover {\n    background-color: #c82333 !important;\n    border-color: #bd2130 !important;\n    color: #ffffff !important;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.4) !important;\n}\n\n/* Estilo para botón disabled - debe verse rojo siempre */\n.proyectsDataToChange-container .setData .btn-danger:disabled,\n.proyectsDataToChange-container .setData .btn-danger[disabled] {\n    background-color: #dc3545 !important;\n    border-color: #dc3545 !important;\n    color: #ffffff !important;\n    opacity: 0.65 !important;\n    cursor: not-allowed !important;\n}\n\n.proyectsDataToChange-container .setData .btn-danger:disabled:hover,\n.proyectsDataToChange-container .setData .btn-danger[disabled]:hover {\n    background-color: #dc3545 !important;\n    border-color: #dc3545 !important;\n    opacity: 0.65 !important;\n}\n\n@media (max-width: 500px) {\n    .proyectsDataToChange-container .currentData .image-container,\n    .proyectsDataToChange-container .currentData .image-placeholder {\n        width: 100%;\n        margin-bottom: 8px;\n    }\n\n    .proyectsDataToChange-container .currentData img {\n        width: 100%;\n        margin-bottom: 8px;\n    }\n\n    .proyectsDataToChange-container .currentData > div {\n        width: 100%;\n        padding-left: 0;\n    }\n\n    .proyectsDataToChange-container .setData {\n        flex-direction: column;\n        justify-content: stretch;\n    }\n\n    .proyectsDataToChange-container .setData button {\n        width: 100%;\n        margin-bottom: 0.5rem;\n    }\n\n    .proyectsDataToChange-container .setData button:last-child {\n        margin-bottom: 0;\n    }\n}\n\n/* Estilos para el panel de filtros */\n.filters-panel .card {\n    background-color: #1a1d29;\n    border: 2px solid #f09502;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n.filters-panel .card-header {\n    background-color: #0e0f15;\n    border-bottom: 2px solid #f09502;\n    padding: 0.75rem 1rem;\n}\n\n.filters-panel .card-header h6 {\n    color: #f09502;\n    font-weight: 600;\n    margin: 0;\n}\n\n.filters-panel .card-body {\n    padding: 1rem;\n    background-color: #1a1d29;\n}\n\n.filters-panel .form-label {\n    font-weight: 500;\n    color: #ffffff;\n    margin-bottom: 0.5rem;\n}\n\n.filters-panel .form-select {\n    background-color: #2a2d3a;\n    border: 1px solid #444;\n    border-radius: 4px;\n    padding: 0.375rem 0.75rem;\n    color: #ffffff;\n}\n\n.filters-panel .form-select:focus {\n    background-color: #2a2d3a;\n    border-color: #f09502;\n    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);\n    color: #ffffff;\n}\n\n.filters-panel .form-select option {\n    background-color: #2a2d3a;\n    color: #ffffff;\n}\n\n.filters-panel .btn-outline-secondary {\n    border-color: #f09502;\n    color: #f09502;\n    background-color: transparent;\n}\n\n.filters-panel .btn-outline-secondary:hover {\n    background-color: #f09502;\n    border-color: #f09502;\n    color: #000000;\n}\n\n.filters-panel .text-muted {\n    color: #adb5bd !important;\n}\n\n/* Responsive para filtros */\n@media (max-width: 768px) {\n    .filters-panel .row .col-md-4 {\n        margin-bottom: 1rem;\n    }\n    \n    .filters-panel .card-body {\n        padding: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
